import { callApiToServer } from '../callApi';

export async function changePassword(
  authtoken,
  passwordObject,
  companyId,
) {
  try{
    let header = {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      "authorization" : "Berear " + authtoken
    };
      
    let body = JSON.stringify({
      password : passwordObject.password,
      companyId : companyId
    });
  
    let endUrl = "v1/auth/change-company-password";
    console.log("endUrl printed here", endUrl);
  
    let responseData = await callApiToServer(body, header, "POST", endUrl);
      
    return responseData;
      
  }catch(err) {
    throw err;
  }
}
